import React, { useState, useEffect } from 'react';
import './product.css'
import Productdata from './Productdata';
export default function Product(props) {
  const [products, setProducts] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState('کمند');
  const [errorget, setErrorget] = useState('')
  const [loadingimage, setLoadingimage] = useState(true)
  const [showproductoflist, setShowproductoflist] = useState('')
  function selectlist(e) {
    setShowproductoflist(e.target.classList.value);
    console.log(e.target.classList.value)
  }

  useEffect(() => {
    fetch('http://185.164.73.170:5000/products')
      .then(response => response.json())
      .then(data => setProducts(data))
      .catch(error => setErrorget('مشکل در اینترنت'));
  }, []);
  const uniqueProducts = [...new Set(products.map(p => p.brand))];

  const getimage = (item) => {
    try {
      return item === '2004' ? require(`../../logo/2004.png`) : item === 'کالت' ? require(`../../logo/cult.png`) : item === 'نانو' ? require(`../../logo/nano.png`) : item === 'سالن فرمولا' ? require(`../../logo/salon.png`) : item === 'ویزیت' ? require(`../../logo/visit.png`) : item === 'ولاستریت' ? require(`../../logo/wella.png`) : item === 'هندسان' ? require(`../../logo/handsan.png`) : item === 'بی می' ? require(`../../logo/beme.png`) : item === 'مکس مور' ? require(`../../logo/maxmoore.png`) : item === 'رابینسون' ? require(`../../logo/robinson.png`) : item === 'مایا' ? require(`../../logo/maya.png`) : item === 'کمند' ? require(`../../logo/kamand.png`) : item === 'مکس دنت' ? require(`../../logo/maxdent.png`) : require(`../../logo/tehranmulogo.jpg`)
    } catch (error) {
      return require(`../../image/error.png`);
    }
  }
  const getRandomBrightColor = () => {
    const randomValue = () => Math.floor(Math.random() * 156) + 100;
    return `rgb(${randomValue()}, ${randomValue()}, ${randomValue()})`;
  };
  return (
    <div className='productpage'>
      {showproductoflist ? <Productdata setShowproductoflist={setShowproductoflist} showproductoflist={showproductoflist} loadingimage={loadingimage} setLoadingimage={setLoadingimage} errorget={errorget} products={products} setSelectedBrand={setSelectedBrand} selectedBrand={selectedBrand} /> : (
        <div className='productlist'>
    <ul>
      {uniqueProducts.map((item, index) => (
        <li
          key={index}
          style={{ backgroundColor: getRandomBrightColor() }} // اعمال رنگ پس‌زمینه
          onClick={selectlist} >
          <img
            loading="lazy"
            src={getimage(item)}
            className={item}
            alt={item}
          />
          <p className={item}>
            {item}
          </p>
        </li>
      ))}
    </ul>
        </div>
      )}
    </div>
  );
}